import React from "react";
var __jsx = React.createElement;
import stl from "./MainImageComponent.module.css";
var MainImageComponent = function MainImageComponent(_ref) {
  var image = _ref.image,
    title = _ref.title,
    className = _ref.className,
    opacityClass = _ref.opacityClass,
    BreadCrumbRenderer = _ref.BreadCrumbRenderer;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.header, " ").concat(className ? className : "")
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: title,
    loading: "eager",
    width: 1530,
    height: 567,
    className: opacityClass ? opacityClass : ""
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.serviceHeroContainer
  }, BreadCrumbRenderer && BreadCrumbRenderer(stl.brdCrmb), /*#__PURE__*/React.createElement("h1", null, title)));
};
export default MainImageComponent;